import { LoadingButton } from "@mui/lab";
import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import ConextManager from "../../../../context";
import CodesContext from "../../context";
import useConfirmCode from "../../service/useConfirmCode";
import useSendEmail from "../../service/useSendEmail";
import ListInputs from "./ListInputs";
import ResendMessage from "./ResendMessage";

// ----------------------------------------------------------------------

export const CodeInputs = () => {
	const context = useContext(CodesContext);
	const conextManager = useContext(ConextManager);

	const { translate } = useLocales();

	const { onSubmit, loading } = useConfirmCode();
	const sendEmail = useSendEmail();

	const disabled =
		context.state.code.some((code) => code === null) || context.state.code.length !== 6;

	const resendEmail = () => {
		sendEmail.onSubmit({ email: conextManager.state.email }, () => {});
	};

	return (
		<Stack sx={{ mt: 3 }} gap={2}>
			<Typography variant='subtitle2'>{translate("demo.verification_code")}</Typography>
			<ListInputs />
			<ResendMessage />
			<Stack flexDirection='row' justifyContent={"flex-end"} mt={2} gap={4}>
				<LoadingButton
					variant='text'
					color='error'
					onClick={() => conextManager.actions.onSendVerificationEmail("")}
				>
					{translate("Reset")}
				</LoadingButton>
				<LoadingButton
					variant='text'
					color='inherit'
					onClick={resendEmail}
					loading={sendEmail.loading}
				>
					{translate("demo.resend")}
				</LoadingButton>
				<LoadingButton variant='contained' onClick={onSubmit} disabled={disabled} loading={loading}>
					{translate("demo.next")}
				</LoadingButton>
			</Stack>
		</Stack>
	);
};

export default CodeInputs;
